
export default {
  props: {
    responsive: {
      default: () => {
        return [
          {
            breakpoint: 575,
            settings: {
              slidesPerView: 1,
              gap: 0,
            },
          },
          {
            breakpoint: 750,
            settings: {
              slidesPerView: 2,
              gap: 10,
            },
          },
          {
            breakpoint: 799,
            settings: {
              slidesPerView: 3,
              gap: 10,
            },
          },
          {
            breakpoint: 1199,
            settings: {
              slidesPerView: 3,
              gap: 10,
            },
          },
        ]
      },
    },
  },
  data() {
    return {
      swiperId: null,
      totalWidth: '100%',
      element: null,
      page: 1,
      pages: 1,
      padding: 240,
    }
  },
  methods: {
    setPage(page) {
      this.page = page
      this.element.style.transform =
        'translateX(-' +
        (this.element.clientWidth - this.padding) * (page - 1) +
        'px)'

      const totalWidth = this.element.scrollWidth // Get the total width including children
      const clientWidth = this.element.clientWidth - this.padding
      this.setChildrenWidth(totalWidth, clientWidth)
    },
    setContainerWidth() {
      const element = document.querySelector(`#${this.swiperId}`) // Select the element
      this.element = element
      const totalWidth = element.scrollWidth // Get the total width including children

      if (element.clientWidth < 992) this.padding = 35
      const clientWidth = element.clientWidth - this.padding

      element.style.width = totalWidth + 'px'

      this.setChildrenWidth(totalWidth, clientWidth)
    },
    setChildrenWidth(totalWidth, clientWidth) {
      const element = document.querySelector(`#${this.swiperId}`) // Select the element
      const children = element.children // Select all children
      const equalWidth = totalWidth / children.length + 'px'
      const response = this.setResponsive(
        clientWidth,
        totalWidth / children.length
      )
      this.totalWidth = ``

      this.element.style.gap = response.settings.gap + 'px'
      this.pages = Math.ceil(children.length / response.settings.slidesPerView)

      const endActiveIndexByPage =
        response.settings.slidesPerView * this.page - 1
      const startActiveIndexByPage =
        response.settings.slidesPerView * (this.page - 1)

      for (let i = 0; i < children.length; i++) {
        const childWidth =
          clientWidth / response.settings.slidesPerView - response.settings.gap
        children[i].style.width = childWidth + 'px'
        if (i <= endActiveIndexByPage && i >= startActiveIndexByPage) {
          children[i].classList.add('active')
        } else {
          setTimeout(() => {
            children[i].classList.remove('active')
          }, 300)
        }
      }
    },
    setResponsive(clientWidth, equalWidth) {
      const items = [...this.responsive]

      return (
        items.reverse().find((r) => r.breakpoint < clientWidth) || {
          breakpoint: 0,
          settings: {
            slidesPerView:
              Math.floor(clientWidth / equalWidth) === 0
                ? 1
                : Math.floor(clientWidth / equalWidth),
            gap: 10,
          },
        }
      )
    },
  },
  created() {
    this.swiperId = 'a' + (Math.random() + 1).toString(36).substring(7)
  },
  mounted() {
    setTimeout(() => {
      this.setContainerWidth()
    }, 250)
  },
}
